<router-outlet></router-outlet>
<!--<app-footer [isShowAppVersion]="isShowAppVersion"></app-footer>-->
<!-- ngx spinner -->
<ngx-spinner bdColor="rgba(0, 0, 0, 0.8)" size="medium" color="#fff" type="square-jelly-box" [fullScreen]="true">
  <p style="color: white"> Loading... </p>
</ngx-spinner>
<!-- toaster container -->
<app-toasts-container aria-live="polite" aria-atomic="true"></app-toasts-container>